export default {"src":"/hedera/_next/static/media/theme_dark.215d35b3.svg","height":24,"width":24};